import { useState } from 'react';
import { createContainer } from 'unstated-next';
import {
  createEmptyField,
  createEmptyMember,
} from '../../../../components/templateEditor/utils';

const useTemplateStore = () => {
  const [fieldsAndTemplates, setFieldsAndTemplates] = useState({
    customFields: [],
    accountingObjects: [],
    defaultFields: {
      series: createEmptyField(),
      company: createEmptyField(),
      voucherText: createEmptyField(),
      transactionText: createEmptyField(),
    },
  });
  const [dirtyState, setDirtyState] = useState(false);

  const makeDirty = () => {
    if (!dirtyState) {
      setDirtyState(true);
    }
  };

  const getDefaultField = props =>
    fieldsAndTemplates.defaultFields[props.fieldName];

  const getField = props => props.rule[props.fieldName];

  const removeFieldMember = (props, memberIndex) => {
    const field = getDefaultField(props);
    field.members.splice(memberIndex, 1);

    makeDirty();
  };

  const getFieldMember = props => {
    const field = getDefaultField(props);
    return field.members[props.memberIndex];
  };

  const changeSource = (props, newValue) => {
    const fieldMember = getFieldMember(props);
    fieldMember.source = newValue;

    makeDirty();
  };

  const changeValue = (props, newValue) => {
    const fieldMember = getFieldMember(props);
    fieldMember.value = newValue;

    makeDirty();
  };

  const changeDelimiter = (props, newValue) => {
    const fieldMember = getFieldMember(props);
    fieldMember.precedingDelimiter = newValue;

    makeDirty();
  };

  const addFieldMember = props => {
    setFieldsAndTemplates(prevFieldMembers => {
      const field = getDefaultField(props);
      field.members.push(createEmptyMember());

      return {
        ...prevFieldMembers,
        defaultFields: {
          ...prevFieldMembers.defaultFields,
          [props.fieldName]: field,
        },
      };
    });

    makeDirty();
  };

  const setUnmappedField = idToRemove => {
    const allDefaultFieldsNames = [
      'series',
      'company',
      'voucherText',
      'transactionText',
    ];

    setFieldsAndTemplates(prevFieldsAndTemplates => {
      allDefaultFieldsNames.forEach(defaultFieldName => {
        const updatedMembers = prevFieldsAndTemplates.defaultFields[
          defaultFieldName
        ].members.map(member => {
          if (member.value === idToRemove) {
            return createEmptyMember();
          }

          return member;
        });

        prevFieldsAndTemplates.defaultFields[defaultFieldName].members =
          updatedMembers;
      });

      return { ...prevFieldsAndTemplates };
    });

    makeDirty();
  };

  return {
    fieldsAndTemplates,
    dirtyState,
    addFieldMember,
    removeFieldMember,
    setFieldsAndTemplates,
    changeValue,
    changeSource,
    changeDelimiter,
    getField,
    setUnmappedField,
    setDirtyState,
  };
};

export const DefaultFieldsContainer = createContainer(useTemplateStore);
